import axios from "axios";
import AdminSlice from "./adminSlice";
import EmployerSlice from "./employerSlice";
import AdminApi from "./services/admin";
import EmployerApi from "./services/employer";


export const EmployerActions = EmployerSlice.actions

export const getPlacementList = () => {
    return async (dispatch:any) => {
        const response = await EmployerApi.getPlacementsDetails()
        dispatch(EmployerActions.setPlacements(response))
    }
}


